import { ICustomerRelationshipShallow } from "@smartrr/shared/entities/CustomerRelationship";

export interface CustomerListState {
  customers: ICustomerRelationshipShallow[];
  totalCount: number;
  totalPages: number;
  pageSize: number;
  pageNumber: number;
  searchQuery: string;
  isLoading: boolean;
}

export const initialState: CustomerListState = {
  customers: [],
  totalCount: 0,
  totalPages: 0,
  pageSize: 30,
  pageNumber: 0,
  searchQuery: "",
  isLoading: false,
};

export type CustomerListAction =
  | { type: "SET_SEARCH_QUERY"; payload: string }
  | { type: "SET_PAGE_NUMBER"; payload: number }
  | { type: "FETCH_CUSTOMERS_START" }
  | {
      type: "FETCH_CUSTOMERS_SUCCESS";
      payload: {
        customers: ICustomerRelationshipShallow[];
        totalCount: number;
        totalPages: number;
        pageSize: number;
        pageNumber: number;
      };
    }
  | { type: "FETCH_CUSTOMERS_ERROR" };

export function customerListReducer(state: CustomerListState, action: CustomerListAction): CustomerListState {
  switch (action.type) {
    case "SET_SEARCH_QUERY": {
      return {
        ...state,
        searchQuery: action.payload,
        pageNumber: 0,
        customers: [],
        isLoading: true,
      };
    }

    case "SET_PAGE_NUMBER": {
      return {
        ...state,
        pageNumber: action.payload,
      };
    }

    case "FETCH_CUSTOMERS_START": {
      return {
        ...state,
        isLoading: true,
      };
    }

    case "FETCH_CUSTOMERS_SUCCESS": {
      return {
        ...state,
        customers: action.payload.customers,
        totalCount: action.payload.totalCount,
        totalPages: action.payload.totalPages,
        pageSize: action.payload.pageSize,
        pageNumber: action.payload.pageNumber,
        isLoading: false,
      };
    }

    case "FETCH_CUSTOMERS_ERROR": {
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}

export const customerListActions = {
  setSearchQuery: (query: string): CustomerListAction => ({
    type: "SET_SEARCH_QUERY",
    payload: query,
  }),

  setPageNumber: (page: number): CustomerListAction => ({
    type: "SET_PAGE_NUMBER",
    payload: page,
  }),

  fetchCustomersStart: (): CustomerListAction => ({
    type: "FETCH_CUSTOMERS_START",
  }),

  fetchCustomersSuccess: (payload: {
    customers: ICustomerRelationshipShallow[];
    totalCount: number;
    totalPages: number;
    pageSize: number;
    pageNumber: number;
  }): CustomerListAction => ({
    type: "FETCH_CUSTOMERS_SUCCESS",
    payload,
  }),

  fetchCustomersError: (): CustomerListAction => ({
    type: "FETCH_CUSTOMERS_ERROR",
  }),
};
